import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BankModel } from './types';
import {ErrorService} from "../../error";
import {catchError} from "rxjs/operators";
import {MessageService} from "../../service/message/message.service";
import {CrudType} from "../../service/message/types";

@Injectable({
  providedIn: 'root',
})
export class BankApiService {
  constructor(private readonly httpClient: HttpClient,
              private readonly errorService:ErrorService,
              private readonly messageService:MessageService
  ) {}

  getById = (id: number): Observable<BankModel> => {
    let parameters: string[];
    parameters = [id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.get<BankModel>(url)
      .pipe(
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        })
      );
  };

  postBank = (bankPost: BankModel): any => {
    let parameters: string[];
    parameters = [];
    let url = this.formatUrl(parameters);
    return this.httpClient.post<BankModel>(url, bankPost, {observe: 'response'})
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.create),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        })
      );
  };

  updateBank = (bankUpdate: BankModel): any => {
    let parameters: string[];
    parameters = [bankUpdate.id.toString()];
    let url = this.formatUrl(parameters);
    return this.httpClient.put<BankModel>(url, bankUpdate, {observe: 'response'})
      .pipe(
        this.messageService.checkStatusCustomOperator(CrudType.update),
        catchError((error) => {
          throw this.errorService.serverErrorRedirect(error);
        })
      );
  };

  formatUrl = (parameters: string[]): string => {
    var url = environment.comparanooapiurl;
    url += environment.features.banks.url;
    parameters.forEach((parameters) => {
      url += '/';
      url += parameters;
    });
    return url;
  };
}
